import { ScriptLoader } from '../utils/script-loader';

/**
 * Load Google Identity Service (GIS) `<script>` element.
 *
 * This ensures that the `google.accounts.*` global object will be available.
 */
export class GoogleIdentityService {
  private readonly gisScript = new ScriptLoader('https://accounts.google.com/gsi/client');

  public isLoaded(): boolean {
    return this.gisScript.isLoaded();
  }

  public async load(): Promise<void> {
    await this.gisScript.load();
  }
}
